<template>
  <div class="main-page">
    <div class="main-page-container">
      <div class="main-page-container-left">
        <search-criteria :selectedOptionTabData="selectedOptionTab" :questionJson="questionJson" @submitFilter="submitFilter" @search="search"></search-criteria>
        <research-report :text="text" :selectedOptionTabData="selectedOptionTab" :pageNumData="pageNum" @noDownloadPermissions="noDownloadPermissions" :isLoading="isLoading" @batchCollectionChart="batchCollectionChart" @batchCollectionText="batchCollectionText"  @figureUncollect="figureUncollect" @textUncollect="textUncollect" @figureCollection="figureCollection" @textCollection="textCollection" @batchDownloadChart="batchDownloadChart" @batchDownloadText="batchDownloadText" @download="download" class="research-report" :highlight="highlight" :chartTotalCount="chartTotalCount" :totalCount="totalCount" :data="pageItems" :chartData="chartPageItems" @selectedTab="selectedTab" @pageNumChange="pageNumChange" @pageOption="pageOption" @sortByOption="sortByOption"></research-report>
      </div>
      <div class="main-page-container-right">
        <search-condition :num="num" @mySearchCondition="mySearchCondition" class="right-content"></search-condition>
        <hot-stocks @mySearchCondition="mySearchCondition" class="right-content"></hot-stocks>
        <hot-special-topic @mySearchCondition="mySearchCondition" class="right-content"></hot-special-topic>
        <research-report-number></research-report-number>
      </div>
    </div>
    <el-dialog
      title="选择收藏夹"
      class="collect-dialog"
      :visible.sync="collectDialogVisible"
      width="410px"
      >
      <div class="dialog-content">
        <input ref="input" @blur="showNewFavoritesInput = false"  v-if="showNewFavoritesInput" type="text" class="dialog-input" v-model.trim="newFavoritesInput" @keypress.enter="onNewFavorites()"/>
        <div v-for="(item, index) in folderNames" :key="index">
          <div class="row folder-name" :class="{'selected-folder-name': folder === item.name}" @click="onFolderNameClick(item.name)">
            <div>{{item.name}}</div>
            <img v-if="folder === item.name" src="../assets/img/check-number.svg" alt="">
          </div>
        </div>
      </div>
      <span slot="footer" class="row dialog-footer">
        <el-button class="btn new-favorites-btn" @click="onDialogNewFavorites">新建收藏夹</el-button>
        <div>
          <el-button class="btn cancel-btn" @click="onDialogCancel">取消</el-button>
          <el-button class="btn confirm-btn" @click="onDialogConfirm">提交</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="兼容提示"
      class="collect-dialog"
      :visible.sync="iePromptDialog"
      width="410px"
      >
      <div class="dialog-content">
        IE浏览器会有部分不兼容情况发生，为了不影响您的使用建议使用Chrome浏览器。
      </div>
      <span slot="footer" class="row dialog-footer">
        <div>
        </div>
        <el-button class="btn confirm-btn" @click="iePromptDialog=false">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      class="members-expired-dialog"
      :visible.sync="membersExpiredDialogVisible"
      width="380px"
      :show-close=false
    >
      <div class="members-expired-dialog-content">
        <img src="../assets/img/members-expired.svg" alt="">
        <div class="members-expired-prompt">您的会员已到期,请续费</div>
        <div class="members-expired-date">会员到期时间: {{this.userInfo}}</div>
        <el-button @click="onRenewalBtnClick" class="renewal-btn">立即续费</el-button>
        <el-button @click="onIgnoreBtnClick" class="ignore-btn">忽略</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 
<script>
import SearchCriteria from "@/components/research-report/SearchCriteria";
import ResearchReport from "@/components/research-report/ResearchReport";
import SearchCondition from "@/components/research-report/SearchCondition";
import ResearchReportNumber from "@/components/research-report/ResearchReportNumber";
import HotStocks from "@/components/research-report/HotStocks";
import HotSpecialTopic from "@/components/research-report/HotSpecialTopic";
import QuestionQuery from "@/rest/questionQuery";
import authService from "@/services/authService";
import localStorageHelper from "@/helpers/localStorageHelper";
import { SEARCH_CONDITION } from "@/helpers/constants";

export default {
  data() {
    return {
      iePromptDialog: false,
      company: "",
      userInfo: "",
      membersExpiredDialogVisible: false,
      num: 1,
      questionJson: null,
      isLoading: false,
      pdfSize: {},
      showNewFavoritesInput: false,
      summariesArray: [],
      idArray: [],
      newFavoritesInput: "",
      folder: "",
      folderNames: [],
      collectDialogVisible: false,
      highlight: {},
      title: {},
      text: {},
      date: {},
      genre: [],
      selectedOptionTab: "text",
      isPrecision: false,
      category: [],
      institution: [],
      industry: [],
      totalCount: 0,
      chartTotalCount: 0,
      pageItems: [],
      pageNum: 1,
      pageSize: 20,
      sortBy: "",
      sortOrder: "",
      chartPageItems: []
    };
  },
  methods: {
    errorPrompt() {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
        this.pageNum = 1;
        this.pageSize = 20;
        this.judge();
      }
    },
    noDownloadPermissions() {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
      }
    },
    onRenewalBtnClick() {
      this.$router.push("/recharge");
    },
    onIgnoreBtnClick() {
      if (this.pageNum !== 1 || this.pageSize !== 20) {
        this.pageNum = 1;
        this.pageSize = 20;
        this.judge();
      }
    },
    mySearchCondition(res) {
      this.pageNum = 1;
      this.questionJson = res;
    },
    submitFilter(res) {
      this.filterConditions = res.filterConditionsData;
      this.category = res.categoryData;
      this.institution = res.institutionData;
      this.industry = res.industryData;
      if (res.pdfSizeData === "1-5页") {
        this.pdfSize = {
          min: 1,
          max: 5
        };
      } else if (res.pdfSizeData === "6-20页") {
        this.pdfSize = {
          min: 6,
          max: 20
        };
      } else if (res.pdfSizeData === "20页以上") {
        this.pdfSize = {
          min: 20,
          max: 1000
        };
      } else {
        this.pdfSize = {};
      }
      this.num++;
    },
    onNewFavorites() {
      if (!this.newFavoritesInput) {
        this.$message({
          message: "文件夹名称不能为空",
          duration: 1000,
          type: "error"
        });
      } else if (this.folderNames.some(item => item.name === this.newFavoritesInput)) {
        this.$message({
          message: "文件夹名称重复",
          duration: 1000,
          type: "error"
        });
      } else {
        this.showNewFavoritesInput = false;
        this.folderNames.unshift({ name: this.newFavoritesInput });
      }
    },
    onDialogNewFavorites() {
      this.newFavoritesInput = "";
      this.showNewFavoritesInput = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    onDialogCancel() {
      this.collectDialogVisible = false;
      this.showNewFavoritesInput = false;
      this.newFavoritesInput = "";
      this.folder = "";
      this.folderNames = [];
    },
    onDialogConfirm() {
      if (this.selectedOptionTab === "text") {
        QuestionQuery.collectPdf(
          this.idArray,
          this.highlight,
          this.summariesArray,
          this.folder
        ).then(() => {
          this.pageItems.forEach(item => {
            if (this.idArray.indexOf(item.id) > -1) {
              item.collected = true;
            }
          });
          this.idArray = [];
          this.summariesArray = [];
        });
      } else if (this.selectedOptionTab === "chart") {
        QuestionQuery.collectFigure(this.idArray, this.highlight, this.folder).then(() => {
          this.chartPageItems.forEach(item => {
            if (this.idArray.indexOf(item.id) > -1) {
              item.collected = true;
            }
          });
          this.idArray = [];
          this.summariesArray = [];
        });
      }
      this.collectDialogVisible = false;
    },
    onFolderNameClick(res) {
      this.folder = res;
    },
    batchCollectionChart(res) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
      } else {
        this.collectDialogVisible = true;
        this.getFolderNames();
        this.idArray = res.map(item => {
          return item.id;
        });
      }
    },
    batchCollectionText(res) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
      } else {
        this.collectDialogVisible = true;
        this.getFolderNames();
        this.idArray = res.map(item => {
          return item.id;
        });
        this.summariesArray = res.map(item => {
          if (!item.text) {
            return [];
            // eslint-disable-next-line
          } else {
            return item.text;
          }
        });
      }
    },
    textUncollect(id) {
      QuestionQuery.uncollectPdf(id).then(() => {
        this.pageItems.forEach(item => {
          if (item.id === id[0]) {
            item.collected = false;
          }
        });
      });
    },
    figureUncollect(id) {
      QuestionQuery.uncollectFigure(id).then(() => {
        this.chartPageItems.forEach(item => {
          if (item.id === id[0]) {
            item.collected = false;
          }
        });
      });
    },
    textCollection(res) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
      } else {
        this.collectDialogVisible = true;
        this.getFolderNames();
        this.idArray = [res.id];
        this.summariesArray = [res.text];
      }
    },
    getFolderNames() {
      QuestionQuery.getDisplay().then(res => {
        this.folderNames = res.folderNames;
      });
    },
    figureCollection(res) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
      } else {
        this.collectDialogVisible = true;
        this.getFolderNames();
        this.idArray = [res.id];
      }
    },
    download(id) {
      this.batchDownloadQuestionQuery([id]);
    },
    batchDownloadText(res) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
      } else {
        const id = res.map(item => {
          return item.id;
        });
        this.batchDownloadQuestionQuery(id);
      }
    },
    batchDownloadChart(res) {
      let id = res.map(item => {
        return item.pdfId;
      });
      id = [...new Set(id)];
      this.batchDownloadQuestionQuery(id);
    },
    batchDownloadQuestionQuery(id) {
      this.$message({
        message: "正在下载...",
        duration: 2000,
        center: true
      });
      QuestionQuery.batchDownload(id).then(
        res => {
          const url = window.URL.createObjectURL(new Blob([res]), {
            type: "application/octet-stream"
          });
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "file.zip");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        () => {
          if (!authService.whoIsLoggedIn()) {
            eventBus.$emit("unLogin");
          }
        }
      );
    },
    pageOption(res) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
        return;
      }
      this.pageSize = res;
      this.pageNum = 1;
      this.judge();
    },
    sortByOption(res) {
      if (res === "按相关度") {
        this.sortBy = "";
        this.sortOrder = "";
      } else if (res === "时间最近") {
        this.sortBy = "date";
        this.sortOrder = "desc";
      } else if (res === "时间最早") {
        this.sortBy = "date";
        this.sortOrder = "asc";
      }
      this.pageNum = 1;
      this.judge();
    },
    selectedTab(res) {
      this.selectedOptionTab = res;
      if (this.selectedOptionTab === "text") {
        this.pageNum = 1;
        this.judge();
      } else if (this.selectedOptionTab === "chart" && !this.text.include && !this.company) {
        this.chartPageItems = [];
        this.chartTotalCount = 0;
      } else {
        this.pageNum = 1;
        this.judge();
      }
    },
    pageNumChange(res) {
      this.pageNum = res;
      this.judge();
    },
    search(res) {
      this.company = res.company;
      this.pageNum = 1;
      this.title = res.title;
      this.text = res.text;
      this.date = res.date;
      this.genre = res.genre;
      this.isPrecision = res.isPrecision;
      if (this.selectedOptionTab === "chart" && !this.text.include && !this.company) {
        this.chartPageItems = [];
        this.chartTotalCount = 0;
      } else {
        this.num++;
        this.judge();
      }
    },
    judge() {
      if (this.pageNum !== 1 && !authService.whoIsLoggedIn()) {
        eventBus.$emit("unLogin");
        return;
      }
      if (!this.isPrecision && this.selectedOptionTab === "text") {
        this.textFuzzy();
      } else if (this.isPrecision && this.selectedOptionTab === "text") {
        this.textPrecision();
      } else if (!this.isPrecision && this.selectedOptionTab === "chart") {
        this.chartFuzzy();
      } else if (this.isPrecision && this.selectedOptionTab === "chart") {
        this.chartPrecision();
      }
    },
    textFuzzy() {
      const params = {
        company: this.company,
        title: this.title,
        text: this.text,
        date: this.date,
        genre: this.genre,
        category: this.category,
        institution: this.institution,
        industry: this.industry,
        pdfSize: this.pdfSize,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      };
      this.pageItems = [];
      this.isLoading = true;
      QuestionQuery.textFuzzy(params).then(
        res => {
          this.isLoading = false;
          this.pageItems = res.pageItems.map((item, index) => {
            if (!index) {
              return {
                keywords: res.highlight.text,
                highlight: res.highlight,
                id: item.id,
                date: item.date,
                title: item.title,
                text: item.text,
                link: item.link,
                institution: item.institution,
                collected: item.collected,
                checked: false,
                showSummary: true
              };
              // eslint-disable-next-line
            } else {
              return {
                keywords: res.highlight.text,
                highlight: res.highlight,
                id: item.id,
                date: item.date,
                title: item.title,
                text: item.text,
                link: item.link,
                institution: item.institution,
                collected: item.collected,
                checked: false,
                showSummary: false
              };
            }
          });
          this.totalCount = res.totalCount;
          this.highlight = res.highlight;
        },
        err => {
          if (
            err.response.status === 500 ||
            err.response.status === 503 ||
            err.response.status === 502
          ) {
            this.isLoading = false;
            this.$message({
              message: "搜索出错了",
              duration: 2000,
              type: "error"
            });
          } else {
            this.errorPrompt();
          }
        }
      );
    },
    textPrecision() {
      this.sortBy = this.sortBy ? this.sortBy : "date";
      const params = {
        company: this.company,
        title: this.title,
        text: this.text,
        date: this.date,
        genre: this.genre,
        category: this.category,
        institution: this.institution,
        industry: this.industry,
        pdfSize: this.pdfSize,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      };
      this.pageItems = [];
      QuestionQuery.textPrecision(params).then(
        res => {
          this.pageItems = res.pageItems.map((item, index) => {
            if (!index) {
              return {
                keywords: res.highlight.text,
                highlight: res.highlight,
                id: item.id,
                date: item.date,
                title: item.title,
                text: item.text,
                link: item.link,
                institution: item.institution,
                collected: item.collected,
                checked: false,
                showSummary: true
              };
              // eslint-disable-next-line
            } else {
              return {
                keywords: res.highlight.text,
                highlight: res.highlight,
                id: item.id,
                date: item.date,
                title: item.title,
                text: item.text,
                link: item.link,
                institution: item.institution,
                collected: item.collected,
                checked: false,
                showSummary: false
              };
            }
          });
          this.totalCount = res.totalCount;
          this.highlight = res.highlight;
          this.sortBy = "";
        },
        err => {
          if (
            err.response.status === 500 ||
            err.response.status === 503 ||
            err.response.status === 502
          ) {
            this.isLoading = false;
            this.$message({
              message: "搜索出错了",
              duration: 2000,
              type: "error"
            });
          } else {
            this.errorPrompt();
          }
        }
      );
    },
    chartPrecision() {
      this.sortBy = this.sortBy ? this.sortBy : "date";
      const params = {
        company: this.company,
        title: this.title,
        text: this.text,
        date: this.date,
        genre: this.genre,
        category: this.category,
        institution: this.institution,
        industry: this.industry,
        pdfSize: this.pdfSize,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      };
      this.chartPageItems = [];
      QuestionQuery.chartPrecision(params).then(
        res => {
          this.chartPageItems = res.pageItems.map(item => {
            return {
              keywords: res.highlight.text,
              highlight: res.highlight,
              id: item.id,
              title: item.title,
              body: item.body,
              date: item.date,
              dataSource: item.dataSource,
              link: item.link,
              institution: item.institution,
              collected: item.collected,
              figureUrl: item.figureUrl,
              figure_page: item.figure_page,
              page: item.page,
              checked: false,
              pdfId: item.pdfID
            };
          });
          this.chartTotalCount = res.totalCount;
          this.highlight = res.highlight;
          this.sortBy = "";
        },
        err => {
          if (
            err.response.status === 500 ||
            err.response.status === 503 ||
            err.response.status === 502
          ) {
            this.isLoading = false;
            this.$message({
              message: "搜索出错了",
              duration: 2000,
              type: "error"
            });
          } else {
            this.errorPrompt();
          }
        }
      );
    },
    chartFuzzy() {
      const params = {
        company: this.company,
        title: this.title,
        text: this.text,
        date: this.date,
        genre: this.genre,
        category: this.category,
        institution: this.institution,
        industry: this.industry,
        pdfSize: this.pdfSize,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      };
      this.chartPageItems = [];
      this.isLoading = true;
      QuestionQuery.chartFuzzy(params).then(
        res => {
          this.isLoading = false;
          this.chartPageItems = res.pageItems.map(item => {
            return {
              keywords: res.highlight.text,
              highlight: res.highlight,
              id: item.id,
              title: item.title,
              body: item.body,
              date: item.date,
              dataSource: item.dataSource,
              link: item.link,
              institution: item.institution,
              collected: item.collected,
              figureUrl: item.figureUrl,
              figure_page: item.figure_page,
              page: item.page,
              checked: false,
              pdfId: item.pdfID
            };
          });
          this.chartTotalCount = res.totalCount;
          this.highlight = res.highlight;
        },
        err => {
          if (
            err.response.status === 500 ||
            err.response.status === 503 ||
            err.response.status === 502
          ) {
            this.isLoading = false;
            this.$message({
              message: "搜索出错了",
              duration: 2000,
              type: "error"
            });
          } else {
            this.errorPrompt();
          }
        }
      );
    },
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        this.iePromptDialog = true;
      }
    }
  },
  created() {
    document.title = "理想绚丽yanbaocool";
    this.isIE();
    eventBus.$on("lookover", event => {
      this.questionJson = event;
    });
  },
  mounted() {
    if (authService.getFromRouter() === "/pdf-detail") {
      const params = JSON.parse(authService.getSearchCondition());
      this.questionJson = params;
      this.company = params.company;
      this.title = params.title;
      this.text = params.text;
      this.date = params.date;
      this.category = params.category;
      this.institution = params.institution;
      this.industry = params.industry;
      this.pdfSize = params.pdfSize;
      this.pageNum = params.pageNum;
      this.sortBy = params.sortBy;
      this.sortOrder = params.sortOrder;
      this.selectedOptionTab = params.selectedOptionTab;
    }
    if (!this.questionJson) {
      this.judge();
    }
    eventBus.$on("isVistor", () => {
      //this.membersExpiredDialogVisible = true;
    });
    eventBus.$on("getUserExpireAt", event => {
      this.userInfo = event;
    });
    eventBus.$on("toPdfDetail", () => {
      const params = {
        company: this.company,
        title: this.title,
        text: this.text,
        date: this.date,
        genre: this.genre,
        category: this.category,
        institution: this.institution,
        industry: this.industry,
        pdfSize: this.pdfSize,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        isPrecision: { isPrecision: this.isPrecision },
        selectedOptionTab: this.selectedOptionTab
      };
      localStorageHelper.setItem(SEARCH_CONDITION, JSON.stringify(params));
    });
  },
  components: {
    SearchCriteria,
    ResearchReport,
    SearchCondition,
    HotSpecialTopic,
    HotStocks,
    ResearchReportNumber
  }
};
</script>
<style lang="scss" scoped>
.main-page {
  overflow: auto;
  width: 100%;
  min-width: 1218px;
  min-height: 100%;
  background: #f7f7fa;
  .main-page-container {
    display: flex;
    margin: 0 auto;
    padding: 24px 0;
    width: 1200px;
    .main-page-container-left {
      margin-right: 24px;
      width: 814px;
      .research-report {
        margin-top: 8px;
      }
    }
    .main-page-container-right {
      width: 378px;
      .right-content {
        margin-bottom: 8px;
      }
    }
  }
  .dialog-input {
    width: 352px;
    height: 32px;
    padding-left: 16px;
    border-radius: 2px;
    border: solid 1px #e5e6ee;
    color: #171f46;
    outline: none;
    &:hover {
      border: solid 1px #999ebe;
    }

    &:focus {
      border: solid 1px #171f46;
    }
  }
  .folder-name {
    justify-content: space-between;
    margin-top: 10px;
    padding: 0 16px;
    width: 352px;
    height: 32px;
    line-height: 32px;
    color: #747990;
    background-color: rgba(0, 11, 92, 0.03);
    border-radius: 2px;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      color: #171f46;
      background-color: rgba(0, 11, 92, 0.06);
    }
  }
  .selected-folder-name {
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.06);
  }
  .dialog-footer {
    justify-content: space-between;
    .btn {
      height: 32px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
    }
    .new-favorites-btn {
      width: 102px;
      color: #747990;
      background-color: rgba(0, 11, 92, 0.03);
      &:hover {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
    }
    .cancel-btn {
      width: 60px;
      color: #171f46;
      background-color: rgba(0, 11, 92, 0.03);
      &:hover {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
    }
    .confirm-btn {
      width: 60px;
      color: #ffffff;
      background-color: #0055ff;
      &:hover {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
    }
  }
}
/deep/.collect-dialog {
  .dialog-content {
    overflow-y: auto;
    max-height: 160px;
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 24px 24px 14px;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      max-height: 300px;
      overflow: auto;
      padding: 0 24px 16px;
    }
    .el-dialog__footer {
      padding: 0 24px 24px;
    }
  }
}

/deep/.members-expired-dialog {
  .members-expired-dialog-content {
    height: 100%;
    width: 100%;
    position: relative;
    padding: 44px 0 28px 88px;
    .members-expired-prompt {
      margin: 12px 0 12px 3px;
      color: #171717;
      font-size: 18px;
      font-weight: 500;
    }
    .members-expired-date {
      margin-left: 16px;
      color: #666666;
      font-size: 12px;
    }
    .renewal-btn {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 78px;
      height: 40px;
      width: 132px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      background-color: #0055ff;
      &:hover {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
    }
    .ignore-btn {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 28px;
      margin-left: 0;
      height: 40px;
      width: 132px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #666666;
      background-color: rgba(0, 11, 92, 0.03);
      &:hover {
        color: #666666;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #666666;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #666666;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
    }
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 0;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      height: 470px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}

::-webkit-scrollbar-track-piece {
  width: 6px;
  background-color: #f7f7fa;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  height: 70px;
  background: rgba(0, 11, 92, 0.03);
  cursor: pointer;
  border-radius: 4px;
}
</style>
